import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ConsentSectionProps {
  marketingConsentCollection: boolean;
  marketingConsentPromotion: boolean;
  marketingConsentEmail: boolean;
  marketingConsentSMS: boolean;
  onChange: (field: string, value: boolean) => void;
}

const ConsentSection: React.FC<ConsentSectionProps> = ({
  marketingConsentCollection,
  marketingConsentPromotion,
  marketingConsentEmail,
  marketingConsentSMS,
  onChange,
}) => {
  const { t } = useTranslation('profile');

  const handlePromotionChange = (checked: boolean) => {
    onChange('marketingConsentPromotion', checked);
    if (!checked) {
      onChange('marketingConsentEmail', false);
      onChange('marketingConsentSMS', false);
    }
  };

  return (
    <div className="space-y-5">
      <h3 className="text-lg font-semibold text-gray-800">
        {t('myProfile.form.consent')}
      </h3>

      <div className="space-y-4">
        {/* 개인정보 수집•이용동의 */}
        <div className="flex items-start gap-3">
          <input
            id="marketingConsentCollection"
            type="checkbox"
            checked={marketingConsentCollection}
            onChange={(e) => onChange('marketingConsentCollection', e.target.checked)}
            className="mt-1 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <div className="flex-1">
            <label htmlFor="marketingConsentCollection" className="text-sm text-gray-700">
              {t('myProfile.form.consentPersonalInfo')}
            </label>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-xs text-gray-400">2025.12.10</span>
              <button
                type="button"
                className="text-xs text-blue-600 hover:text-blue-800 underline"
                onClick={() => window.open('/legal/marketing-consent-collection', '_blank')}
              >
                {t('myProfile.form.consentViewDetails')}
              </button>
            </div>
          </div>
        </div>

        {/* 광고성 정보 수신 동의 (parent) */}
        <div className="flex items-start gap-3">
          <input
            id="marketingConsentPromotion"
            type="checkbox"
            checked={marketingConsentPromotion}
            onChange={(e) => handlePromotionChange(e.target.checked)}
            className="mt-1 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <div className="flex-1">
            <label htmlFor="marketingConsentPromotion" className="text-sm text-gray-700">
              {t('myProfile.form.consentMarketing')}
            </label>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-xs text-gray-400">2025.12.10</span>
              <button
                type="button"
                className="text-xs text-blue-600 hover:text-blue-800 underline"
                onClick={() => window.open('/legal/marketing-consent-promotion', '_blank')}
              >
                {t('myProfile.form.consentViewDetails')}
              </button>
            </div>
          </div>
        </div>

        {/* SMS / Email sub-checkboxes (only when promotion is checked) */}
        {marketingConsentPromotion && (
          <div className="ml-7 space-y-3">
            <div className="flex items-center gap-2">
              <input
                id="marketingConsentSMS"
                type="checkbox"
                checked={marketingConsentSMS}
                onChange={(e) => onChange('marketingConsentSMS', e.target.checked)}
                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <label htmlFor="marketingConsentSMS" className="text-sm text-gray-700">
                {t('myProfile.form.consentSMS')}
              </label>
            </div>
            <div className="flex items-center gap-2">
              <input
                id="marketingConsentEmail"
                type="checkbox"
                checked={marketingConsentEmail}
                onChange={(e) => onChange('marketingConsentEmail', e.target.checked)}
                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <label htmlFor="marketingConsentEmail" className="text-sm text-gray-700">
                {t('myProfile.form.consentEmail')}
              </label>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsentSection;
